export enum PageType {
  Home = 'home',
  Team = 'team',
  League = 'league',
  Profile = 'profile',
}
